import { getEnvOrDefault } from './runtime-env';

export enum Environment {
  Development = 'development',
  Test = 'tst',
  Preproduction = 'pre',
  Production = 'prd',
}

/**
 * Environment config.
 *
 * @property {string} environment='development' - App environment name.
 */
const environmentConfig = {
  get environment() {
    return getEnvOrDefault('NEXT_PUBLIC_APP_ENV', Environment.Development);
  },
  get defaultUserEmailAddress() {
    return getEnvOrDefault(
      'NEXT_PUBLIC_DEFAULT_USER_EMAIL_ADDRESS',
      'default.user@example.com',
    );
  },
};

export default environmentConfig;
